var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel slide"
  }, [(_vm.showIndicators) ? _c('ol', {
    staticClass: "carousel-indicators"
  }, _vm._l((_vm.children.length), function(_, index) {
    return _c('li', {
      class: {
        active: _vm.active === index
      },
      on: {
        "click": function($event) {
          _vm.active = index
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showControl) ? [_c('a', {
    staticClass: "carousel-control-prev",
    class: {
      disabled: _vm.active <= 0
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.toPrev
    }
  }, [_c('span', {
    staticClass: "carousel-control-prev-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "carousel-control-next",
    class: {
      disabled: _vm.active >= _vm.children.length
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.toNext
    }
  }, [_c('span', {
    staticClass: "carousel-control-next-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])] : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-689344b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/Carousel.vue
// module id = 139
// module chunks = 19